export default "__VITE_ASSET__6QoODCFR1BdmEH1P_s4O3g__"